import { BaseApiService } from '../base/BaseApiService';
import { ApiResponse } from '../../types/api';

export interface AccessSettingDto {
  id: string;
  roleName: string | null;
  startTime: string;
  endTime: string;
  allowedDays: string;
  isActive: boolean;
  description: string | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface CreateAccessSettingDto {
  roleName?: string | null;
  startTime: string;
  endTime: string;
  allowedDays?: string;
  isActive?: boolean;
  description?: string | null;
}

export interface UpdateAccessSettingDto {
  roleName?: string | null;
  startTime?: string;
  endTime?: string;
  allowedDays?: string;
  isActive?: boolean;
  description?: string | null;
}

class AccessSettingsService extends BaseApiService {
  async getAll(): Promise<AccessSettingDto[]> {
    const response = await this.api.get<ApiResponse<AccessSettingDto[]>>('/accesssettings');
    return this.extractData(response);
  }

  async getById(id: string): Promise<AccessSettingDto> {
    const response = await this.api.get<ApiResponse<AccessSettingDto>>(`/accesssettings/${id}`);
    return this.extractData(response);
  }

  async create(data: CreateAccessSettingDto): Promise<AccessSettingDto> {
    const response = await this.api.post<ApiResponse<AccessSettingDto>>('/accesssettings', data);
    return this.extractData(response);
  }

  async update(id: string, data: UpdateAccessSettingDto): Promise<AccessSettingDto> {
    const response = await this.api.put<ApiResponse<AccessSettingDto>>(`/accesssettings/${id}`, data);
    return this.extractData(response);
  }

  async delete(id: string): Promise<void> {
    await this.api.delete(`/accesssettings/${id}`);
  }
}

export const accessSettingsService = new AccessSettingsService();
